export const GET_FAQS_REQUEST = 'faq/GET_FAQS_REQUEST';
export const GET_FAQS_SUCCESS = 'faq/GET_FAQS_SUCCESS';
export const GET_FAQS_FAILURE = 'faq/GET_FAQS_FAILURE';
